"use client";

/**
 * A crash outside the CRM pages' own boundary (the Lightning shell itself,
 * the sign-in pages): "Sorry to interrupt" with Refresh over the whole
 * screen. The providers (language, theme, auth) sit above it and still work.
 */
import { CrashScreen } from "@/components/lightning/shell/crash-screen";

export default function RootError({ error, retry, reset }: { error: Error & { digest?: string }; retry?: () => void; reset: () => void }) {
  return <CrashScreen error={error} onRetry={retry ?? reset} fullPage />;
}
